import { addLabelForSelect, addWrapperForSelect, bindOptionToSelect, initDropDown } from "../../../controls/LoadDropDown";
import { queryMode, queryTask } from "../../../utils/querying/gis-data";
export function cascadingDropdownPreparingElement(settings) {
    return initDropDown(settings);
}
export async function getDropdownData(options, columns) {
    options.mode = queryMode.Features;
    let data = await queryTask(options);
    return data.features.map((item) => {
        return {
            id: item.attributes[columns.id],
            value: item.attributes[columns.value],
            geometry: item.geometry
        };
    });
}
export function cascadingDropdownHandler(selectElements) {
    let itemByKeys = Object.keys(selectElements.elements);
    let wrapperSelect = {
        parent: selectElements.parentContainer,
        textAlign: "right"
    };
    for (let i = 0; i < itemByKeys.length; i++) {
        const el = itemByKeys[i];
        let wraperDiv = addWrapperForSelect(wrapperSelect, selectElements.elements[el].element.id);
        addLabelForSelect(wraperDiv, selectElements.elements[el].element.id, selectElements.elements[el].label);
        wraperDiv.appendChild(selectElements.elements[el].element);
        wrapperSelect.parent.appendChild(wraperDiv);
    }
}
export function bindOption(data) {
    bindOptionToSelect(data);
}
